<!--Footer Starts-->
<footer class='footer'>
    <p class='copyright clearfix text-muted m-0'>
        Copyright &copy; {{currentDate | date: 'yyyy'}} <a href='https://www.binariogp.it'>BinarioGP</a>
        <span class='d-none d-sm-inline-block'>, All rights reserved. Version {{version}}</span>
    </p>
</footer>
<!--Footer Ends-->
